import { useAtom } from "jotai"

import { isFixedPanelOpenAtom } from "~/managers/AddToCartFixedPanelManager"

export function useIsFixedPanelOpen() {
  return useAtom(isFixedPanelOpenAtom)
}
